import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { IssueFilterKeys, type QualityIssueType } from '../../../../shared/issuesV2';
import * as IssuesV2Store from '../../../redux/issuesV2';
import { useSetFilterHasChanged } from '../../../redux/savedFilters/hooks';
import FilterCardCheckboxes from '../../generic/Filter/FilterCardCheckboxes';
import FilterPanel from '../../generic/Filter/FilterPanel';
import useFetchIssuesAction from '../IssuesInbox/hooks/useFetchIssuesAction';
import type { SelectOption } from '../../../types';
import type { SelectedOptionsProps } from '../../generic/Filter/CheckboxFilterGroup';

const BASE_FILTER_OPTIONS: SelectOption[] = [
  { value: 'outdated_dependency', label: 'Outdated version' },
  { value: 'blacklisted_dependency', label: 'Blocked package' },
  { value: 'risk_abandonware', label: 'Abandonware' },
  { value: 'risk_empty-package', label: 'Empty package' },
  { value: 'risk_native-code', label: 'Native code' },
];

const QualityIssueFilter: VoidFunctionComponent<Omit<SelectedOptionsProps, 'onSelect'>> = ({ selectedOptions }) => {
  const setFilters = useFetchIssuesAction(IssuesV2Store.actions.setFilter);
  const stateFilters = useSelector(IssuesV2Store.selectors.getFilter);
  const setFilterHasChanged = useSetFilterHasChanged();

  const selectedCheckboxes = (selectedOptions ?? []).map((option: string) => ({
    label: BASE_FILTER_OPTIONS.find(filterOption => filterOption.value === option)?.label || option,
    value: option,
  }));

  const onCheckboxChange = (newSelected: SelectOption[]) => {
    setFilters({
      ...stateFilters,
      [IssueFilterKeys.Type]: newSelected.map(({ value }) => value as QualityIssueType),
    });
    setFilterHasChanged(true);
  };

  return (
    <FilterPanel>
      <FilterCardCheckboxes
        label="Issue type"
        options={BASE_FILTER_OPTIONS}
        values={selectedCheckboxes}
        onChange={onCheckboxChange}
        testId="issues-quality-filters"
      />
    </FilterPanel>
  );
};

export default QualityIssueFilter;
